import type { EmailsIndex } from '@/types';
import { EmailList } from './components/EmailList';
import { EmailStats } from './components/EmailStats';

export default function Index({
  emails,
  stats,
  pagination,
  search,
}: EmailsIndex) {
  return (
    <main className="flex-1">
      <div className="container space-y-6 py-6">
        <div>
          <h1 className="font-bold text-3xl">Email Management</h1>
          <p className="text-muted-foreground">View and manage all sent emails</p>
        </div>

        <EmailStats stats={stats} />
        <EmailList emails={emails} pagination={pagination} search={search} />
      </div>
    </main>
  );
}
